import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const Tooltip = ({
  id,
  message: customMessage,
  icon,
  place,
  arrowBorderColor,
  children
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { tooltipMessage }
  } = localizedStrings;

  return (
    <>
      {children}
      <div
        data-type="info"
        data-tip="React-tooltip"
        data-for={`${id}`}
        data-html
        style={{ display: 'inline', marginLeft: '0.75rem' }}
      >
        <i className={`fa ${icon}`} />
      </div>
      <ReactTooltip
        id={`${id}`}
        effect="float"
        arrowColor="#fff"
        border="true"
        borderColor={arrowBorderColor}
        className="orderTrackingToolTip"
        place={place}
      >
        {customMessage || tooltipMessage}
      </ReactTooltip>
    </>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  message: PropTypes.string,
  id: PropTypes.number.isRequired,
  icon: PropTypes.string,
  place: PropTypes.string,
  arrowBorderColor: PropTypes.string
};

Tooltip.defaultProps = {
  message: '',
  icon: 'fa-question-circle',
  place: 'top',
  arrowBorderColor: '#66CC00'
};

export default Tooltip;
